import { render, staticRenderFns } from "./DemoHomeLayout.vue?vue&type=template&id=013a2e38&scoped=true&"
import script from "./DemoHomeLayout.vue?vue&type=script&lang=js&"
export * from "./DemoHomeLayout.vue?vue&type=script&lang=js&"
import style0 from "./DemoHomeLayout.vue?vue&type=style&index=0&id=013a2e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013a2e38",
  null
  
)

export default component.exports